import * as form from '../form';

export const financialLien = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        EntityType: form.radio(xitem.EntityType),
        EntityTypeExplain: form.textarea(xitem.EntityTypeExplain),
        EntityName: form.text(xitem.EntityName),
        PrivateName: form.name(xitem.PrivateName),
        PropertyType: form.radio(xitem.PropertyType),
        PropertyTypeExplain: form.textarea(xitem.PropertyTypeExplain),
        LienReason: form.radio(xitem.LienReason),
        WhyExplain: form.textarea(xitem.WhyExplain),
        AmountRequiredToPay: form.number(xitem.AmountRequiredToPay),
        When: form.datecontrol(xitem.When),
        Current: form.branch(xitem.Current),
        WhenResolved: form.datecontrol(xitem.WhenResolved),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        OfficeName: form.text(xitem.OfficeName),
        OfficeLocation: form.location(xitem.OfficeLocation),
        CaseNum: form.text(xitem.CaseNum),
        CaseNumIdk: form.notapplicable(xitem.CaseNumIdk),
      },
    };
  });
  return {
    HasLien: form.branch(data.HasLien),
    List: form.collection(items, (data.List || {}).branch),
  };
};
